import React, { useState } from 'react';
import { Card, Typography, Badge, Empty, Row, Col } from 'antd';
import { HostVulneravel, TopVulnerabilidade } from '../../../types/dashboard/csa.types';

const { Text } = Typography;

interface CSATopListsProps {
  hostsVulneraveis: HostVulneravel[];
  topVulnerabilidades: TopVulnerabilidade[];
  loading?: boolean;
  onHostClick?: (host: string) => void;
  onCveClick?: (cve: string) => void;
}

const CSATopLists: React.FC<CSATopListsProps> = ({ 
  hostsVulneraveis, 
  topVulnerabilidades, 
  loading = false,
  onHostClick,
  onCveClick
}) => {
  const [hoveredHostIndex, setHoveredHostIndex] = useState<number | null>(null);
  const [hoveredCveIndex, setHoveredCveIndex] = useState<number | null>(null);

  const renderHostsList = () => {
    if (!hostsVulneraveis || hostsVulneraveis.length === 0) {
      return <Empty description="Nenhum dado disponível" />;
    }

    return (
      <div style={{ padding: '8px 0' }}>
        {hostsVulneraveis.slice(0, 5).map((host, index) => (
          <div 
            key={index} 
            style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              padding: '8px 0',
              borderBottom: index < 4 ? '1px solid #f0f0f0' : 'none',
              cursor: onHostClick ? 'pointer' : 'default',
              borderRadius: '4px',
              backgroundColor: hoveredHostIndex === index ? '#f5f5f5' : 'transparent',
              transition: 'background-color 0.2s ease'
            }}
            onClick={() => onHostClick && onHostClick(host.host)}
            onMouseEnter={() => onHostClick && setHoveredHostIndex(index)}
            onMouseLeave={() => setHoveredHostIndex(null)}
          >
            <div style={{ flex: 1, minWidth: 0 }}>
              <Text strong ellipsis title={host.host}>
                {host.host}
              </Text>
              {onHostClick && (
                <div style={{ 
                  fontSize: '10px', 
                  color: '#8c8c8c', 
                  marginTop: '2px'
                }}>
                  Clique para filtrar
                </div>
              )}
            </div>
            <Badge 
              count={host.vulnerabilidades} 
              style={{ backgroundColor: '#ff4d4f', marginLeft: 8 }}
              showZero
            />
          </div>
        ))}
      </div>
    );
  };

  const renderCVEsList = () => {
    if (!topVulnerabilidades || topVulnerabilidades.length === 0) {
      return <Empty description="Nenhum dado disponível" />;
    }

    return (
      <div style={{ padding: '8px 0' }}>
        {topVulnerabilidades.slice(0, 5).map((vuln, index) => (
          <div 
            key={index} 
            style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              padding: '8px 0',
              borderBottom: index < 4 ? '1px solid #f0f0f0' : 'none',
              cursor: onCveClick ? 'pointer' : 'default',
              borderRadius: '4px',
              backgroundColor: hoveredCveIndex === index ? '#f5f5f5' : 'transparent',
              transition: 'background-color 0.2s ease'
            }}
            onClick={() => onCveClick && onCveClick(vuln.cve)}
            onMouseEnter={() => onCveClick && setHoveredCveIndex(index)}
            onMouseLeave={() => setHoveredCveIndex(null)}
          >
            <div style={{ flex: 1, minWidth: 0 }}>
              <Text code title={vuln.cve}>
                {vuln.cve}
              </Text>
              {onCveClick && (
                <div style={{ 
                  fontSize: '10px', 
                  color: '#8c8c8c', 
                  marginTop: '2px'
                }}>
                  Clique para filtrar
                </div>
              )}
            </div>
            <Badge 
              count={vuln.count} 
              style={{ backgroundColor: '#1890ff', marginLeft: 8 }}
              showZero
            />
          </div>
        ))}
      </div>
    );
  };

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} lg={12}>
        <Card 
          title="IPs Mais Vulneráveis" 
          size="small" 
          loading={loading}
        >
          {renderHostsList()}
        </Card>
      </Col>
      <Col xs={24} lg={12}>
        <Card 
          title="Top CVEs/CVE Pendentes/Não aplicáveis" 
          size="small" 
          loading={loading}
        >
          {renderCVEsList()}
        </Card>
      </Col>
    </Row>
  );
};

export default CSATopLists;